import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { sendParticipantData } from '../../services/participants'
import { onSetResetItemSelectedSuccess } from '../ManageParticipants/ManageParticipants.actions'
import { onSetOpenToastSuccess } from '../UserNotificationToast/UserNotificationToast.actions'
import { ERROR_MESSAGE, CUSTOM_ERROR_TITLES } from '../../config/settings/constants'
import { onSetErrorModalSuccess } from '../ErrorParticipantModal/ErrorParticipantModal.actions'

export const SET_MODAL_SHOW_SUCCESS = 'SET_MODAL_SHOW_SUCCESS'

export const onSetModalShowSuccess = makeActionCreator(SET_MODAL_SHOW_SUCCESS, 'payload')

export const SET_SHOW_SUCCESS_TOAST = 'SET_SHOW_SUCCESS_TOAST'

export const onSetShowSuccessToast = makeActionCreator(SET_SHOW_SUCCESS_TOAST, 'payload')

export const SEND_PARTICIPANT_DATA = 'SEND_PARTICIPANT_DATA'
export const SEND_PARTICIPANT_DATA_ERROR = 'SEND_PARTICIPANT_DATA_ERROR'
export const SEND_PARTICIPANT_DATA_SUCCESS = 'SEND_PARTICIPANT_DATA_SUCCESS'

export const onSendParticipantData = makeActionCreator(SEND_PARTICIPANT_DATA)
export const onSendParticipantDataError = makeActionCreator(SEND_PARTICIPANT_DATA_ERROR, 'payload')
export const onSendParticipantDataSuccess = makeActionCreator(SEND_PARTICIPANT_DATA_SUCCESS, 'payload')

export const onSendParticipantDataThunk = payload => async dispatch => {
  dispatch(onSendParticipantData())
  try {
    const { onSuccessCallback, handleGoParticipant, ...rest } = payload
    await sendParticipantData({ body: rest, actionType: SEND_PARTICIPANT_DATA })
    return batch(() => {
      dispatch(onSetResetItemSelectedSuccess())
      dispatch(onSetShowSuccessToast({ showSuccessToast: true }))
      onSuccessCallback()
      handleGoParticipant()
    })
  } catch (error) {
    dispatch(onSetOpenToastSuccess({ open: true, message: ERROR_MESSAGE, severity: 'error' }))
    const {
      originalError: {
        response: {
          data: { errores: errors }
        }
      }
    } = error
    if (Array.isArray(errors)) {
      dispatch(onSetModalShowSuccess({ showAddParticipantModal: false }))
      const errorMessages = errors.map(({ descripcion: errorDescription }) => errorDescription)
      const { addParticipant } = CUSTOM_ERROR_TITLES
      dispatch(onSetErrorModalSuccess({ showErrorParticipantModal: true, errorMessages, errorTitle: addParticipant }))
    }
    return dispatch(onSendParticipantDataError({ error }))
  }
}
